.installButton {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  text-align: center;

  &.inline {
    .extension {
      height: 4.375rem;
      min-height: 0;
      max-height: 4.5rem;
      padding: 0 2.375rem;
      font-size: 1.375rem;
      white-space: nowrap;
    }
  }

  .extension {
    display: none;
    align-items: center;
    min-width: 1.5rem;
    max-width: 100%;
    min-height: 1.5rem;
    max-height: unset;
    padding: 0 3rem;
    border-radius: 3rem;
    color: var(--neutral);
    font-weight: 500;
    font-size: 1.875rem;
    line-height: 130%;
    text-decoration: none;
    background:
      linear-gradient(90.87deg, #249674 0%, #2fb38b 100%),
      radial-gradient(
        100% 100% at 50% 0%,
        rgba(31, 193, 145, 0.5) 0%,
        rgba(23, 160, 119, 0.5) 100%
      ),
      radial-gradient(
        116.67% 1239.2% at 4.45% 50%,
        rgba(101, 255, 209, 0.24) 0%,
        rgba(36, 150, 116, 0.24) 100%
      );

    @media (min-width: 769px) {
      display: flex;
      height: 4.25rem;
      padding: 0 2.5rem;
      font-size: 1.5rem;
    }

    &:hover {
      color: var(--neutral);
      background: var(--primary-gradient-700);
    }

    &:active {
      color: var(--neutral);
      background: var(--primary-gradient-700);
    }
  }

  .appStore {
    align-self: center;
    min-width: 10rem;
    height: 4.125rem;
    border-radius: 0.75rem;

    @media (min-width: 769px) {
      display: none;
    }

    img {
      width: auto;
      max-width: unset;
      height: 100%;
    }
  }

  .rating {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 1.3125rem 0 0;

    @media (min-width: 1025px) {
      margin: 1.375rem 0 0;
    }

    .stars {
      display: flex;
      align-items: center;
      margin: 0 0.5rem 0.4375rem 0;
      column-gap: 0.125rem;

      @media (min-width: 400px) {
        margin: 0 0.6875rem 0.375rem 0;
      }

      @media (min-width: 1281px) {
        margin: 0 0.625rem 0.375rem 0;
      }

      svg {
        width: 1.125rem;
        height: 1.125rem;

        @media (min-width: 1025px) {
          width: 1.25rem;
          height: 1.25rem;
        }
      }
    }

    .ratingText {
      margin: 0 0 0.375rem;
    }

    .divider {
      display: inline-block;
      position: relative;
      top: 0.125rem;
      height: 1.125rem;
      margin: 0 0.75rem;
      border-right: 0.125rem solid currentColor;

      @media (min-width: 400px) {
        height: 1.1875rem;
        margin: 0 0.875rem;
      }
    }
  }
}
